import { useQuery } from '@tanstack/react-query';

import { IAdditionalCodesItemReturn } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const retrieveAdditionalCodes = async ({ id }): Promise<IAdditionalCodesItemReturn[]> => {
  try {
    const { data } = await request({
      path: `batches/${id}/retrieve-additional-codes`,
      method: 'PATCH',
      authenticate: true,
    });
    return data;
  } catch (error) {
    showErrorToast(error, 'Error fetching the additional codes!');
  }
};

export const useRetrieveAdditionalCodes = (id: string) =>
  useQuery({
    queryKey: ['additional-codes', id],
    queryFn: () => retrieveAdditionalCodes({ id }),
    enabled: !!id,
    placeholderData: [],
  });
